import { useT } from "@transifex/react";
import { Exercises } from "../enums/exercises";
import { getExerciseTypeByQuestionMode } from "../helpers/ExerciseTypesHelper";

const useExerciseTitle = () => {
    const t = useT();

    const t_standardTitle = t("Standard", { _tags: "CreateTest,SelectExerciseType" });
    const t_connectWordsTitle = t("Connect Words", { _tags: "CreateTest,SelectExerciseType" });
    const t_gapSentenceTitle = t("Gap sentence", { _tags: "CreateTest,SelectExerciseType" });
    const t_taskPerWordTitle = t("Task per word", { _tags: "CreateTest,SelectExerciseType" });
    const t_textTaskTitle = t("Text task", { _tags: "CreateTest,SelectExerciseType" });
    const t_verbtrainingTitle = t("Verbtraining", { _tags: "CreateTest,SelectExerciseType" });

    const ExerciseTypesExerciseName = new Map<Exercises, string>([
        [Exercises.STANDARD, t_standardTitle],
        [Exercises.WRITE_SENTENCE, t_taskPerWordTitle],
        [Exercises.CREATE_TEXT, t_textTaskTitle],
        [Exercises.FILL_GAP, t_gapSentenceTitle],
        [Exercises.CONNECT_WORDS, t_connectWordsTitle],
        [Exercises.VERBTRAINING, t_verbtrainingTitle],
        [Exercises.FREE_TEXT, t_textTaskTitle],
    ]);

    function getExerciseNameFromQuestionMode(questionMode?: string) {
        if (!questionMode) return "";
        const exerciseKey = getExerciseTypeByQuestionMode(questionMode);
        if (!exerciseKey) return "";
        return ExerciseTypesExerciseName.get(exerciseKey) || "";
    }

    return { getExerciseNameFromQuestionMode, ExerciseTypesExerciseName };
};

export default useExerciseTitle;
